<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addExchangeGoods"
        >新增商品</el-button
      >
    </div>
    <div class="tab-content">
      <el-table :data="activeList" style="width: 100%" :max-height="550">
        <el-table-column
          align="left"
          prop="activityName"
          label="活动名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="startTime"
          label="有效时间"
          width="380"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="timeStatus" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.timeStatus == 1
                ? "未开始"
                : scope.row.timeStatus == 2
                ? "进行中"
                : scope.row.timeStatus == 3
                ? "已结束"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="lookDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="updateActive(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="delActive(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="activeList.length > 0" style="padding-left:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  Marketing_activityList,
  getActivityListTotalNum,
  deleteActivity,
} from "../api/index";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      activeList: [],
    };
  },
  mounted() {
    this.getMarketing_activityList();
  },
  methods: {
    getMarketing_activityList(timeStatus) {
      Marketing_activityList({
        activityType: 5,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        timeStatus: timeStatus,
      }).then((res) => {
        getActivityListTotalNum({
          activityType: 5,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
          timeStatus: timeStatus,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.activeList = res.data;
        } else if (res.code == -1) {
          this.activeList = [];
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getMarketing_activityList();
    },
    addExchangeGoods() {
      this.$router.push("/exchange/addAndEdit");
    },
    lookDetail(row) {
      console.log(row, "lookDetail");
      localStorage.setItem("activityId", row.activityId);
      this.$router.push("/exchange/detail");
    },
    updateActive(row) {
      console.log(row, "updateActive");
      localStorage.setItem("updateActivityId", row.activityId);
      this.$router.push("/exchange/addAndEdit");
    },
    delActive(row) {
      console.log(row, "delActive");
      this.$confirm("此操作将永久删除该活动, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteActivity({
          activityId: row.activityId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getMarketing_activityList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
}
</style>
